module.exports = __webpack_public_path__ + "manzama-logotype-bb0b7cc4f423964f3dbafc585ef19e2c.svg";